import ReactDOM from 'react-dom/client';
import { Root } from './components/Root';

import './mockEnv';
import './index.css';
import '@telegram-apps/telegram-ui/dist/styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
